export default __webpack_public_path__ + "static/media/VA.f4a4044c.png";